// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1RErf","alert":"SettungsInbox_alert__24uiu"};